<template>
  <div class="h100pc">
    <div>
      <img
        class="back"
        @click="goHome"
        v-lazy="require('./../../../assets/img/back2.png')"
      />
      <div class="hd bggray">
        <span class="hd_span f16" v-if="all">我的测评</span>
        <span class="hd_span f16" v-if="!all">我的报告</span>
        <div class="input" v-if="all" @click="openValue">
          <div class="f14 select">
            <span class="select_txt">{{ options[value].text }}</span>
            <img src="./../../../assets/img/test/down-arrow-1.png" alt="" />
          </div>
          <div class="list" v-if="show">
            <ul>
              <li
                v-for="(item, index) in options"
                @click.stop="getValue(index, item)"
                :key="item.value"
              >
                {{ item.text }}
                <hr />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="testlist w100pc">
        <div class="overlay" v-if="show" @click="openValue"></div>
        <NoPic style="margin-top: 50%" v-if="!testLen"></NoPic>
        <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">
          <van-list
            v-model="isUpLoading"
            :finished="upFinished"
            :immediate-check="false"
            :offset="10"
            finished-text="我是有底线的"
            @load="onLoadList"
          >
            <FinishList :tests="myTests" :type="all"></FinishList>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
import FinishList from "@/components/FinishList";
import NoPic from "@/components/NoPic";
import { getMyTest } from "@/http/api";
export default {
  name: "myTest",
  data() {
    return {
      testLen: 0,
      show: false,
      all: false,
      value: 0,
      typeArr: ["", "unassessed", "unfinished", "finished"],
      options: [
        { text: "全部测评", value: 0 },
        { text: "未完成", value: 1 },
        { text: "进行中", value: 2 },
        { text: "已完成", value: 3 },
      ],
      myTests: [],

      // 分页
      total: 0,
      pageSize: 10, // 每页条数
      pageIndex: 1, // 页码
      isDownLoading: false, // 下拉刷新
      isUpLoading: false, // 上拉加载
      upFinished: false, // 上拉加载完毕
      offset: 100, // 滚动条与底部距离小于 offset 时触发load事件
    };
  },
  created() {
    if (this.$route.path.includes("all")) {
      this.all = true;
    }
    this.getroadList();
  },
  watch: {
    show(val) {
      console.log("val", val);
      return val;
    },
  },

  methods: {
    // 模拟select组件
    goHome() {
      this.$router.push("/my/center");
    },
    openValue() {
      this.show = !this.show;
    },
    getValue(index, item) {
      this.myTests = [];
      this.value = item.value;
      this.show = false;
      console.log("show", this.show);
      let params = {
        page: this.pageIndex,
        page_size: this.pageSize,
      };
      if (this.value) {
        params.is_finished = this.typeArr[this.value];
      }
      getMyTest(params).then((res) => {
        console.log(res);
        this.total = res.data.count;
        if (res.data.objects) {
          this.myTests = this.myTests.concat(res.data.objects);
          this.show = false;
          console.log("this.myTests", this.myTests);
        }
      });
    },
    getroadList() {
      let params = {
        page: this.pageIndex,
        page_size: this.pageSize,
        // is_finished: 'finished'
      };
      if (!this.all) {
        params.is_finished = "finished";
      }
      if (this.value) {
        params.is_finished = this.typeArr[this.value];
      }
      getMyTest(params)
        .then((res) => {
          console.log("我的测评", res);
          this.total = res.data.count;
          if (res.data.objects) {
            this.myTests = this.myTests.concat(res.data.objects);
            this.testLen = this.myTests.length;
          }
        })
        .finally(() => {
          this.isDownLoading = false;
          this.isUpLoading = false;
        });
    },
    // 下拉刷新
    onDownRefresh() {
      this.myTests = [];
      this.pageIndex = 1;
      this.upFinished = false; // 不写这句会导致你上拉到底过后在下拉刷新将不能触发下拉加载事件
      this.getroadList(); // 加载数据
    },
    // 上拉加载请求方法
    onLoadList() {
      console.log("sss");
      if (this.total > this.pageIndex * this.pageSize) {
        this.pageIndex++;
        this.getroadList();
      } else {
        this.upFinished = true;
      }
    },
  },
  components: {
    FinishList,
    NoPic,
  },
};
</script>

<style lang="less" scoped>
.back {
  width: 22px;
  height: 23px;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left: 5px;
  top: 5px;
}
.hd {
  height: 40px;
  margin-left: 0 !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .hd_span {
    margin-left: 40px;
  }
  .input {
    // width: 31%;
    height: 40px;
    // font-size: small;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    position: relative;
    // input {
    //   border: none;
    //   width: 100px;
    //   text-align: end;
    //   margin-right: 36px;
    // }
    .select {
      height: 100%;
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 23px;
      .select_txt {
        display: inline-block;
        height: 14px;
        margin-right: 5px;
      }
      img {
        width: 7px;
        height: 7px;
      }
    }
  }
  .list {
    position: absolute;
    top: 40px;
    right: 0;
    z-index: 2;
    width: 138px;
    border-radius: 0 0 10px 10px;
    background: white;
    li {
      font-size: 16px;
      line-height: 34px;
      color: #d6d6d6;
      text-align: center;
      hr {
        margin: 0;
      }
    }
    li:last-child {
      hr {
        display: none;
      }
    }
  }
}

.testlist {
  // overflow: scroll;
  position: relative;

  height: 92%;
  .overlay {
    position: fixed;
    top: 40px;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 1;
  }
}
</style>